import { useCallback } from 'react';

/**
 * Small helper for document chat flows (worker registry, future forms).
 * Keeps exit semantics in one place when shells gain deep links later.
 */
export function useDocumentChatNavigation(onExitToChecklist: () => void) {
  const exitToChecklist = useCallback(() => {
    onExitToChecklist();
  }, [onExitToChecklist]);

  return { exitToChecklist };
}
